import { CheckProps } from "components/Atoms/SelectInputFilter/SelectInputFilterModel";

export enum Filters {
  present,
  past,
}

export interface IProps {
  type: Filters;
  month?: number;
  year?: number;
  setYear?: React.Dispatch<React.SetStateAction<number>>;
  setMonth?: React.Dispatch<React.SetStateAction<number>>;
  setCheckedState?: React.Dispatch<React.SetStateAction<CheckProps>>;
  checkedState?: CheckProps;
}
